import { useTranslation } from 'react-i18next'
import {
  ListBulletIcon,
  Squares2X2Icon,
  TableCellsIcon,
} from '@heroicons/react/24/outline'
import type { BookmarkViewMode } from '../../../../types/bookmark'

interface ViewModeToggleProps {
  value: BookmarkViewMode
  onChange: (mode: BookmarkViewMode) => void
}

const MODES: Array<[BookmarkViewMode, string, typeof Squares2X2Icon]> = [
  ['grid', 'bookmark.gridView', Squares2X2Icon],
  ['compact', 'bookmark.compactView', TableCellsIcon],
  ['list', 'bookmark.listView', ListBulletIcon],
]

/** 목록 표현 전환 (카드 / 조밀 / 줄) */
export default function ViewModeToggle({
  value,
  onChange,
}: ViewModeToggleProps) {
  const { t } = useTranslation()

  return (
    <div className="hidden rounded-lg bg-gray-100 p-1 dark:bg-gray-700 md:flex">
      {MODES.map(([mode, labelKey, Icon]) => (
        <button
          key={mode}
          type="button"
          aria-label={t(labelKey)}
          aria-pressed={value === mode}
          onClick={() => onChange(mode)}
          className={`rounded-md p-2 transition ${
            value === mode
              ? 'bg-white text-gray-900 shadow-sm dark:bg-gray-600 dark:text-white'
              : 'text-gray-500 hover:text-gray-700 dark:text-gray-400'
          }`}
        >
          <Icon className="h-4 w-4" />
        </button>
      ))}
    </div>
  )
}
